import { SpoProductNaturesResponse, SpoUserSettingsResponse } from '@spo/types';
import { SelectOptions } from './types';
import { buildSportsOptionsFromSportsIds } from './utils';

export const getDataSport = async (
  userConfiguration: SpoUserSettingsResponse,
): Promise<SelectOptions[]> => {
  let sports: SelectOptions[] = [];

  if (userConfiguration?.sportIds) {
    sports = await buildSportsOptionsFromSportsIds(userConfiguration.sportIds);
  }

  return sports;
};

export const getDataNature = async (
  searchedNaturesData: SpoProductNaturesResponse | undefined,
): Promise<SelectOptions[]> => {
  let natures: SelectOptions[] = [];
  if (searchedNaturesData?.length) {
    natures = searchedNaturesData?.map((nature) => ({
      label: `${nature?.externalReferential?.id} - ${nature?.externalReferential?.name}`,
      value: nature?.externalReferential?.id || -1,
      name: `${nature?.externalReferential?.name}`,
    }));
  }
  return natures;
};
